import React, { useState, useMemo } from "react";
import { useSequence } from "../../../hooks/fetch_api_hook/useSequence";
import { useClasseContext } from "../../../context/ClasseContext";
import { useUser } from "../../../context/UserContext";
import { url } from "../../../utils/confserveur";
import RoadMapClasse from "./RoadMapClasse";
import Loading from "../../general/Loading";
function ProgressionClasse() {
  const { classeNom } = useClasseContext();
  const {user , etablissementData} = useUser();
  const [reloadSequence, setReloadSequence] = useState(false);
  const [selectedView, setSelectedView] = useState("planning"); // Vue par défaut : planning
  const { data: listSequences, isLoading } = useSequence(
    `${url}sequences/?etablissement=${etablissementData.id}`,
    reloadSequence
  );

  const selectedNiveau = useMemo( ()=> {
    if(classeNom[0] === '6'){
        return '6eme'
    }
    else if(classeNom[0] ==='5'){
        return '5eme'
    }
    else if(classeNom[0] === '4'){
        return '4eme'
    }
    else if(classeNom[0] === '3'){
        return '3eme'
    }
  },[classeNom])
  
  // Filtrer les séquences pour la classe sélectionnée
  const filteredSequences = useMemo(() => {
    if (!listSequences || !classeNom) return [];
    return listSequences.filter(
      (sequence) => sequence.niveau === selectedNiveau && sequence.est_commune
    );
  }, [listSequences, classeNom, selectedNiveau]);

  
  // Gestion du rechargement des séquences
  const handleReload = () =>{
    setSelectedView("planning")
     setReloadSequence((prevState) => !prevState);

  }

  const handleChangeView = (view) => {
    setSelectedView(view)
    if(view ==='progress'){
      setReloadSequence((prevState) => !prevState)
    }
  }
  const onToggleAccompli = () => {
    return true;
  }

  if(isLoading){
    return(
      <Loading loadingText={"Chargement des séquences.."} /> 
    )
  }

  return (
    <div className="flex flex-col w-full h-full pilotage-enter">
      {/* RoadMapClasse avec les onglets intégrés */}
      <RoadMapClasse
        filteredSequences={filteredSequences}
        selectedNiveau={selectedNiveau}
        classeNom={classeNom}
        selectedView={selectedView}
        onChangeView={handleChangeView}
        // Props pour SuiviProgressionProf
        classes={etablissementData && etablissementData.classes}
        listSequences={listSequences}
        profClassIds={etablissementData && etablissementData.professeurs.find((prof) => prof.id === user.id).classes}
        onToggleAccompli={onToggleAccompli}
        handleReload={handleReload}
      />
    </div>
  );
}

export default ProgressionClasse;